// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"31":"4791c43f","75":"465a27c6","378":"18ce6e9f","607":"55109e69","661":"72373663","737":"1ebbc1c6","923":"bc380ca8","926":"be326218"}[chunkId] + ".chunk.js";
};